module.exports = "https://cb-static.prod-my.games/promo/twitchdrops/img/footer-logo-mygames@2x.3b9303ba.png";